import { WALLET_FISERV_ERROR_CODE } from '../constants/fiservError';
import { ISelectedWallet, IWallet, IWalletResponse } from '../store/interface';

const FUNDING_CATEGORIES = {
  CHECK: 'Check',
  DEBIT: 'Debit',
  CREDIT: 'Credit',
};

export const addTypeToWalletsList = (
  wallets: Array<IWalletResponse>,
): Array<IWallet> => {
  return wallets.map((wallet) => walletWithType(wallet));
};

const walletWithType = (wallet: IWalletResponse): IWallet => {
  // type can be calculated based on funding category, bank with have fundingCategory as Check and card will have Debit/Credit
  return {
    ...wallet,
    type:
      wallet.fundingCategory === FUNDING_CATEGORIES.CHECK
        ? 'BANK ACCOUNT'
        : 'CARD',
  };
};

export const getFilteredWalletData = (
  selectedWallet?: ISelectedWallet,
  wallets?: Array<IWallet>,
): IWallet | undefined => {
  let filteredWalletObject = {} as IWallet;
  if (selectedWallet && wallets) {
    wallets.filter((wallet) => {
      if (
        wallet.fundingAccountLastFourDigit ===
          selectedWallet.fundingAccountLastFourDigit &&
        wallet.fundingAccountToken === selectedWallet.fundingAccountToken
      ) {
        filteredWalletObject = wallet;
      }
    });
    return filteredWalletObject;
  }
};

/**
 * This function is used to check known wallet error code,show alert in same page and no redirection should happen
 *
 */
export const isWalletErrorKnown = (errorCode: string): boolean => {
  if (Object.values(WALLET_FISERV_ERROR_CODE).indexOf(errorCode || '') > -1)
    return true;
  return false;
};

/**
 * Function to format nickname by appending space,3 dots and fundingAccountLastFourDigit to the nickname
 * @param nickName
 * @param fundingAccountLastFourDigit
 */
export const getUIFormatForWalletNickname = (
  nickName: string,
  fundingAccountLastFourDigit: string,
): string => {
  const regex = new RegExp(`([.]{3}${fundingAccountLastFourDigit})$`, 'g');
  if (regex.test(nickName)) return nickName;
  else return `${nickName} ...${fundingAccountLastFourDigit}`;
};

export const getPaymentTypeFromSelectedWallet = (
  wallets?: Array<IWallet>,
  fundingAccountToken?: string,
) => {
  const selectedWallet = wallets?.find(
    (wallet) => wallet.fundingAccountToken === fundingAccountToken,
  );
  return {
    type: selectedWallet?.type,
    fundingCategory: selectedWallet?.fundingCategory,
  };
};
